/**
 * EBBA Design System Breakpoints
 * Based on common responsive design patterns
 */
export const BREAKPOINTS = {
  xs: 480,   // Extra small devices (phones)
  sm: 640,   // Small devices (large phones)
  md: 768,   // Medium devices (tablets)
  lg: 1024,  // Large devices (laptops)
  xl: 1280,  // Extra large devices (desktops)
  '2xl': 1536, // 2X large devices (large desktops)
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;

/**
 * Responsive breakpoint ranges for common device types
 */
export const DEVICE_BREAKPOINTS = {
  mobile: { min: 0, max: BREAKPOINTS.md - 1 },
  tablet: { min: BREAKPOINTS.md, max: BREAKPOINTS.lg - 1 },
  desktop: { min: BREAKPOINTS.lg, max: Infinity },
} as const;

export type DeviceType = keyof typeof DEVICE_BREAKPOINTS; 